import React, { MouseEvent } from 'react'
import CalendarIcon from 'transfix-icons/build/CalendarIcon'
import CloseIcon from 'transfix-icons/build/CloseIcon'
import DownArrowIcon from 'transfix-icons/build/DownArrowIcon'
import IconButton from 'transfix-ui/components/IconButton'
import { makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'

interface IDateRangePickerLabelProps {
  /**
   * @example 'Pickup Date'
   */
  label: string
  className: string
  /**
   * @default false
   */
  showClearAction?: boolean
  onClick: () => void
  onClear?: (event: MouseEvent<HTMLElement>) => void
}

const useDateRangeStyles = makeStyles(() => ({
  calendarIcon: {
    display: 'flex',
  },
  actionIcon: {
    display: 'flex',
    color: brandColors.skyBlue6,
  },
}))

export const DateRangePickerButton = ({
  className,
  label,
  onClear,
  onClick,
  showClearAction = false,
}: IDateRangePickerLabelProps) => {
  const classes = useDateRangeStyles()

  return (
    <button className={className} onClick={onClick} data-test='DateRangePickerButton'>
      <span className={classes.calendarIcon}>
        <CalendarIcon size='large' />
      </span>
      <strong>{label}</strong>
      <span className={classes.actionIcon}>
        {showClearAction && onClear ? (
          <IconButton noPadding color='tertiary' size='small' Icon={CloseIcon} onClick={onClear} />
        ) : (
          <DownArrowIcon size='medium' />
        )}
      </span>
    </button>
  )
}
